// components/BrickWallField.jsx
import React from 'react';
import { BrickWallSegment } from './BrickWallSegment';

const wallPieces = [
  //picnic table area
  { variant: 'column', position: [36.3, 1.4, 25], rotationY: 0 },
  { variant: 'short',  position: [36,   1.4, 25], rotationY: 0 },
  { variant: 'corner', position: [40.5, 1.4, 24.8], rotationY: 1.75 },
  { variant: 'long',   position: [40.5, 1.4, 24],   rotationY: 1.75 },
  { variant: 'corner', position: [41, 1.4, 18],   rotationY: 1.75 }, 
  { variant: 'long',   position: [40.9, -2, -0.75],   rotationY: 1.75 },
  { variant: 'long',   position: [39.99, -2, -6.2],   rotationY: 1.75 },
   { variant: 'long',   position: [42, -1.5, 5.15],   rotationY: 1.75 },
  // { variant: 'column', position: [39, 1.1, 0], rotationY: 0.2 },
  { variant: 'short',   position: [39, -2, -12],   rotationY: 1.75 },

  // courtyard/garden area
 { variant: 'column', position: [-36, 1.4, 25], rotationY: 0 },
 { variant: 'short',  position: [-39, 1.4, 25], rotationY: 0 },
 { variant: 'corner', position: [-40.09, 1.4, 25], rotationY: 0 },
 { variant: 'long',   position: [-36, 2.4, 24],   rotationY: 1.76 },
 { variant: 'long',   position: [-38, 1.4, 18.5],   rotationY: 1.65 },
 { variant: 'long',   position: [-37, 1.4, 12.75],   rotationY: 1.45 },

    // "front" entrance to parking lot - south wall; parking lot side
 { variant: 'column', position: [-2.4, 0, -14], rotationY: 0 },
 { variant: 'corner', position: [-2.5, -0.5, -15.59], rotationY: 3.2 },
 { variant: 'long',   position: [-10, -0.5, -15.5],   rotationY: 0 },
 { variant: 'long',   position: [-16, -0.5, -15.5],   rotationY: 0 },
 { variant: 'long',   position: [-22, -0.5, -15.5],   rotationY: 0 },
 { variant: 'long',   position: [-28, -0.5, -15.5],   rotationY: 0 },
 { variant: 'long',   position: [-34, -0.5, -15.5],   rotationY: 0 },
 { variant: 'corner', position: [-35.5, -0.5, -15.5], rotationY: 4.7 },
 { variant: 'long',   position: [-35.65, -0.5, -8],   rotationY: 1.55 },


    // "front" entrance to neighborhood - south wall; neighboorhood side
  { variant: 'column', position: [2.4, 0, -14], rotationY: 0 },
  { variant: 'corner', position: [2.4, -0.5, -15.25], rotationY: 4.7 },
  { variant: 'long',   position: [3, -0.5, -15.15],   rotationY: 0 },
  { variant: 'long',   position: [9, -0.5, -15],   rotationY: 0 },
  { variant: 'long',   position: [15, -0.5, -15],   rotationY: 0 },
  { variant: 'long',   position: [21, -0.5, -15],   rotationY: 0 },
  { variant: 'long',   position: [27, -0.5, -15],   rotationY: 0 },
  { variant: 'long',   position: [33, -0.5, -15],   rotationY: 0 },

];

export function BrickWallField() {
  return (
    <group>
      {wallPieces.map((piece, i) => (
        <BrickWallSegment
          key={i}
          variant={piece.variant}
          position={piece.position}
          rotation={[0, piece.rotationY, 0]}
          scale={1.5}
        />
      ))}
    </group>
  );
}
